module.exports = __webpack_public_path__ + "img/eye.38b069ba.svg";